<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
    v-bind:class="activeFund > 0 ? '' : 'overlay'"
  >
    <CSidebarBrand>
      <CIcon
        custom-class-name="sidebar-brand-full"
        :icon="logoNegative"
        :height="35"
      />
      <CIcon
        custom-class-name="sidebar-brand-narrow"
        :icon="sygnet"
        :height="35"
      />
    </CSidebarBrand>
    <AppSidebarNav v-if="myCurrency" :currency="myCurrency" />
    <CSidebarToggler
      class="d-none d-lg-flex"
      @click="$store.commit('toggleUnfoldable')"
    />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore, mapActions } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    return {
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
    }
  },
  data() {
    return {
      activeFund: 0,
      myCurrency: '',
    }
  },

  async mounted() {
    await this.getMyFundraisers()
  },

  methods: {
    ...mapActions(['GetFundraisers']),
    async getMyFundraisers() {
      let accFundraisers = await this.GetFundraisers({
        userID: this.$store.state.auth.user.user.userID,
        step: 5,
      })
      this.activeFund = accFundraisers.fundraisers
      if (accFundraisers.fundraisers > 0) {
        this.myCurrency = accFundraisers.currency
      } else {
        this.myCurrency = 'kes'
      }
    },
  },
}
</script>
